'use strict';

"use strict";
const pluginVersion = "12.4.2";
const defaultOptions = {
  showImage: true
};

exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
